<template>
  <full-width>
    <back-button />
    <h2
      class="flex items-center justify-center mt-4 text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
      data-e2e-attr="myorders-page"
    >
      My Orders
    </h2>
    <!--------------------->
    <!-- PROFILE DETAILS -->
    <!--------------------->
    <div
      v-if="hasInit"
      class="w-full py-8 mt-8 text-white order:px-4 tmsk-blue-bg sm:px-16"
    >
      <div  class="flex flex-col justify-center max-w-lg px-4 mx-auto space-y-2">
        <h3 data-e2e-attr="myorder-date-display" class="text-2xl font-bold text-center">COLLECTION END DATE:</h3>
        <h3  data-e2e-attr="myorder-date-display" class="flex justify-center mb-4 text-2xl font-bold text-center"> {{ collectionEndDate }}
          <tooltip color="white" data-e2e-attr="myorder-tooltip">
            <p data-e2e-attr="myorder-tooltip-date-display">The last day for collection is {{collectionEndDateLong}}. Please collect all your masks by this date. No refunds or exchanges after collection for hygiene reasons.
            </p>
          </tooltip>
        </h3>
        <p class="font-bold text-white">My Profile</p>
        <p class="text-white">
          Registered Mobile: {{ mobileNumbers.accountNumber }}
        </p>
      </div>
    </div>
    <!------------->
    <!-- RECEIPT -->
    <!------------->
    <div
      v-if="hasInit"
      class="flex flex-row items-center justify-center mt-6 space-x-4"
    >
      <div class="w-full max-w-lg px-4">
        <table v-if="listofTransactions.length > 0" class="w-full table-auto">
          <thead>
            <tr>
              <th class="p-2 text-left border-b-2">Receipt</th>
              <th class="p-2 text-left border-b-2">Date</th>
              <th class="p-2 text-left border-b-2">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="txn in listofTransactions" :key="txn.uuid">
              <td class="px-2 py-4 border-b-2">
                <span
                  class="underline cursor-pointer hover:text-gray-400"
                  @click="redeem(txn)"
                >
                  {{ txn.uuid.split("-")[0] }}
                </span>
              </td>
              <td class="px-2 py-4 border-b-2">
                {{ formatDate(new Date(txn.timestamp)) }}
              </td>
              <td class="px-2 py-4 border-b-2">
                <template v-if="['success', 'exchanged'].includes(txn.status)">
                  {{
                    isCollected(txn.items) ? "Collected" : "Pending Collection"
                  }}
                </template>
                <template v-else-if="txn.status === 'refunded'">
                  Refunded
                </template>
                <template v-else> Pending Collection </template>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="flex items-center justify-center py-12 space-x-6">
          <p class="tmsk-blue-text">You have no pre-orders.</p>
          <img class="w-16" src="@/assets/img/oops.png" />
        </div>
      </div>
    </div>
    <!-- <div class="flex justify-center mt-15">
      <card
        class="cursor-pointer w-72 wrap:w-96"
        :onClick="
          () =>
            goToExternalLink(
              'http://stayprepared.sg/sizing-guide'
            )
        "
      >
        <template #body>
          <div class="flex flex-row items-center justify-start space-x-4">
            <img src="@/assets/img/home-size-chart.png" class="h-16" />
            <p class="flex-1 text-xl font-bold tmsk-blue-text">
              Mask Sizing Guide
            </p>
          </div>
        </template>
      </card>
    </div> -->
    <div class="flex justify-center mt-8">
      <card
        v-if="isPreOrderActive"
        data-e2e-attr="my-orders-page-pre-order-btn"
        class="cursor-pointer w-72 wrap:w-96"
        :onClick="() => reroute('Purchase')"
      >
        <template #body>
          <div class="flex flex-row items-center justify-start space-x-4">
            <div class="flex items-center justify-center h-16 -ml-16">
              <img
                src="@/assets/img/home-pre-order-additional-masks.png"
                class="h-24 -mb-6"
              />
            </div>
            <p class="flex-1 text-xl font-bold tmsk-blue-text">
              Pre-order Additional Masks
            </p>
          </div>
        </template>
      </card>
    </div>
    <div class="flex justify-center mt-8">
      <card
        class="cursor-pointer w-72 wrap:w-96"
        :onClick="() => reroute('LocateVendingMachines')"
      >
        <template #body>
          <div class="flex flex-row items-center justify-start space-x-4">
            <img
              src="@/assets/img/home-locate-vending-machines.png"
              class="h-16"
            />
            <p class="flex-1 text-xl font-bold tmsk-blue-text">
              Locate Vending Machines
            </p>
          </div>
        </template>
      </card>
    </div>
  </full-width>
</template>

<script>
import beepAPI from '../../mixins/beepAPI'
import BackButton from '../../components/BackButton'
import FullWidth from '../../components/Layout/FullWidth'
import Card from '../../components/Card'
import { mapState, mapActions, mapGetters } from 'vuex'
import Tooltip from '../../components/Tooltip'
import { COLLECTION_END_DATE } from '../../Constants'
import moment from 'moment'

export default {
  name: 'History',
  metaInfo () {
    return {
      title: 'My Orders',
      // meta: [
      //   { property: 'og:title', content: 'My Orders' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'My Orders' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [{ rel: 'canonical', href: window.location.href }]
    }
  },
  components: {
    BackButton,
    FullWidth,
    Card,
    Tooltip
  },
  mixins: [beepAPI],
  props: {},
  data () {
    return {
      hasInit: false
    }
  },
  computed: {
    ...mapState(['isLoggedIn', 'transactionHistory', 'mobileNumbers']),
    ...mapGetters(['activeBreakpoint', 'isPreOrderActive']),

    listofTransactions () {
      const transactions = this.transactionHistory
        .filter((txn) =>
          ['success', 'refunded', 'exchanged'].includes(txn.status)
        )
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))

      const refundedArray = transactions.filter(
        (txn) => txn.status === 'refunded'
      )
      const uncollectedArray = []
      const collectedArray = []
      transactions.forEach((txn) => {
        if (txn.status !== 'refunded') {
          let uncollected = 0

          txn.items.forEach(({ qtyUncollected }) => {
            uncollected += qtyUncollected
          })

          if (uncollected === 0) collectedArray.push(txn)
          else uncollectedArray.push(txn)
        }
      })

      return [...uncollectedArray, ...refundedArray, ...collectedArray]
    }
  },
  watch: {
    listofTransactions (newValue) {
      if (newValue.length > 0) setTimeout(this.paintCanvas, 50)
    }
  },

  // Lifecycle Hooks
  beforeCreate () {},
  created () {
    this.collectionEndDate = moment(COLLECTION_END_DATE).format('DD MMM YYYY').toUpperCase()
    this.collectionEndDateLong = moment(COLLECTION_END_DATE).format('dddd, DD MMM, hh:mma')
  },
  beforeMount () {},
  mounted () {
    this.setIsLoading(true)
    if (this.isLoggedIn) {
      Promise.all([
        this.handleFetchTransactionHistory(),
        this.handleFetchProducts()
      ])
        .then(
          () => {
            this.hasInit = true
            this.setIsLoading(false)
          },
          () => {
            this.setIsLoading(false)
          }
        )
    } else {
      this.setIsLoading(false)
      this.$router.push({ name: 'Login', query: this.$route.query })
    }
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateTransactionHistory', 'updateProducts']),

    paintCanvas () {
      var collection = document.querySelectorAll('.canvas')
      for (let i = 0; i < collection.length; i++) {
        const canvas = collection[i]
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
      }
    },

    isCollected (items) {
      // qtyUncollected > 0 = pending collection
      const uncollectedItem = items.find(item => item.qtyUncollected > 0)
      if (uncollectedItem === undefined) return true
      else return false
    },

    handleFetchTransactionHistory () {
      return new Promise((resolve, reject) => {
        this.getTransactionHistory().then(
          (response) => {
            this.updateTransactionHistory(response).then(resolve)
          },
          (error) => {
            console.error(error)
            this.createModal({
              title: 'Something went wrong',
              message: 'Failed to fetch transaction history.',
              btnMessage: 'Proceed',
              callback: () => {}
            })
            reject(error)
          }
        )
      })
    },

    handleFetchProducts () {
      return new Promise((resolve, reject) => {
        this.getProducts().then(
          (response) => {
            this.updateProducts(response).then(resolve)
          },
          (error) => {
            console.error(error)
            this.createModal({
              title: 'Something went wrong',
              message: 'Failed to fetch products.',
              btnMessage: 'Proceed',
              callback: () => {}
            })
            reject(error)
          }
        )
      })
    },

    reroute (name) {
      this.$router.push({ name: name, query: this.$route.query })
    },

    redeem (txn) {
      this.$router.push({ name: 'OrderReceipt', params: { receipt: txn.uuid.split('-')[0] }, query: { ...this.$route.query } })
    },

    goToExternalLink (url) {
      window.open(url, '_blank')
    },

    formatDate (value) {
      const date = new Date(value)
      const day = date.toLocaleString('default', { day: '2-digit' })
      const month = date.toLocaleString('default', { month: 'short' })
      return day + ' ' + month
    }
  }
}
</script>

<style scoped></style>
